module.exports = __webpack_public_path__ + "img/attention_image.1ab0fd86.jpg";